module.exports = __webpack_public_path__ + "static/media/title_toushin.5d4cab51.svg";